
// Calculate billing totals based on portfolio data
export const calculateBillingTotals = (portfolioData: any) => {
  const billingData = portfolioData.billingData || {
    activeBusinesses: [],
    pausedBusinesses: [],
    managedBudgets: [],
    availableCredits: 0,
    promotionalDiscount: 0
  };
  
  // Calculate the sum of all active business monthly fees
  const activeBusinessTotal = billingData.activeBusinesses?.reduce(
    (total: number, business: { monthlyFee: number }) => total + (business.monthlyFee || 0), 
    0
  ) || 0;
  
  // Calculate the sum of all managed budgets
  const managedBudgetTotal = billingData.managedBudgets?.reduce(
    (total: number, budget: { budget: number }) => total + (budget.budget || 0), 
    0
  ) || 0;
  
  // Calculate total with credits and discounts
  const subtotal = activeBusinessTotal + managedBudgetTotal;
  const afterCredits = Math.max(0, subtotal - (billingData.availableCredits || 0));
  const afterDiscount = Math.max(0, afterCredits - (billingData.promotionalDiscount || 0));
  
  return {
    businessFees: activeBusinessTotal,
    managedBudgets: managedBudgetTotal,
    subtotal,
    availableCredits: billingData.availableCredits || 0,
    promotionalDiscount: billingData.promotionalDiscount || 0,
    totalCharge: afterDiscount
  };
};

// Format currency for display
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  }).format(amount);
};
